import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import "./AgentDetailModal.css";
import UserDetailModal from "../UserDetailModal/UserDetailModal";
import HistoryDetailModal from "../HistoryDetailModal/HistoryDetailModal";
import CreateUserModal from "../CreateUserModal/CreateUserModal";
import { useRolePermission } from "../../hooks/useRolePermission";
import { useLocalSearch } from "../../hooks/useLocalSearch";
const TABS = [
    "Thông tin Đại lý",
    "Hạn mức",
    "Thông tin User",
    "Lịch sử Đại lý",
    "Lịch sử User",
    "Hồ sơ đăng ký",
];
const getStatusInfo = (status) => {
    switch (status) {
        case "ACTIVE":
        case "Hoạt động":
            return { class: "status-active", text: "Hoạt động" };
        case "CLOSED":
        case "Đóng":
            return { class: "status-closed", text: "Đóng" };
        case "LOCKED":
        case "Tạm khóa":
            return { class: "status-locked", text: "Tạm khóa" };
        case "WAITING_ACTIVATION":
        case "PENDING":
        case "Chờ kích hoạt":
            return { class: "status-pending", text: "Chờ kích hoạt" };
        default:
            return { class: "", text: status };
    }
};
const AgentDetailModal = ({ isOpen, onClose, agent }) => {
    const [activeTab, setActiveTab] = useState("Thông tin Đại lý");
    const [selectedUser, setSelectedUser] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [userHistoryDetail, setUserHistoryDetail] = useState(null);
    const [isUserHistoryDetailOpen, setIsUserHistoryDetailOpen] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);

    // --- State cho danh sách Users ---
    const [users, setUsers] = useState([]);
    const searchableUsers = useMemo(() => {
        return users.map(user => ({
            ...user,
            // Thêm trường statusText chứa tiếng Việt để tìm kiếm bắt được
            statusText: getStatusInfo(user.status).text,

            // Nếu muốn tìm theo cả tên User tạo hay Branch tạo mà API trả về null/undefined
            // Bạn có thể xử lý luôn ở đây để tìm kiếm mượt hơn:
            searchableCreatedBy: user.created_by || "",
            searchableBranch: user.branch_created || user.branch_code || ""
        }));
    }, [users]);
    const {
        searchTerm: userSearchTerm,
        setSearchTerm: setUserSearchTerm,
        filteredData: filteredUsers
    } = useLocalSearch(searchableUsers);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [isLoadingDocs, setIsLoadingDocs] = useState(false);
    const [history, setHistory] = useState([]);
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    // --- MỚI: State Lịch sử User ---
    const [userHistory, setUserHistory] = useState([]);
    const [isLoadingUserHistory, setIsLoadingUserHistory] = useState(false);
    const { permissions } = useRolePermission();
    // Reset tab về mặc định khi mở modal mới
    // 1. Khi mở Modal lên, chỉ reset Tab về mặc định.
    useEffect(() => {
        if (isOpen) {
            setActiveTab("Thông tin Đại lý");
        }
    }, [isOpen]);

    // 2. Khi ID của Agent thay đổi (hoặc tắt mở lại với agent khác), mới Reset dữ liệu cũ đi
    useEffect(() => {
        if (isOpen) {
            setUsers([]);
            setDocuments([]);
            setHistory([]);
            setUserHistory([]);
        }
    }, [isOpen]);


    // 3. Gọi API khi Active Tab thay đổi HOẶC khi Agent thay đổi (và Modal đang mở)
    useEffect(() => {
        if (!isOpen || !agent?.id) return;

        switch (activeTab) {
            case "Thông tin User":
                fetchUsers();
                break;
            case "Hồ sơ đăng ký":
                fetchDocuments();
                break;
            case "Lịch sử Đại lý":
                fetchHistory();
                break;
            case "Lịch sử User":
                fetchUserHistory();
                break;
            default:
                break;
        }
    }, [isOpen, activeTab, agent?.id]);


    const fetchUsers = async () => {
        // Kiểm tra an toàn: Nếu không có ID thì không gọi
        if (!agent?.id) return;

        setIsLoadingUsers(true);
        try {
            const token = localStorage.getItem("access_token");
            // Sửa lại URL cho chắc chắn đúng
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/agent/${agent.id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                // Log lỗi để debug nếu cần
                console.error("Fetch users failed:", response.status);
                throw new Error("Failed to fetch users");
            }

            const data = await response.json();
            console.log("user", data);
            const userList = Array.isArray(data) ? data : (data.data || []);
            setUsers(userList);

        } catch (error) {
            console.error("Error fetching users:", error);
            setUsers([]); // Reset về rỗng nếu lỗi
        } finally {
            setIsLoadingUsers(false);
        }
    };
    // --- MỚI: Hàm fetch Documents ---
    const fetchDocuments = async () => {
        setIsLoadingDocs(true);
        try {
            const token = localStorage.getItem("access_token");
            // API: GET /api/v1/admin/agents/{id}/documents
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/documents`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) throw new Error("Failed to fetch documents");

            const data = await response.json();
            // Map dữ liệu trả về (Giả định data là mảng hoặc data.data)
            const docsList = Array.isArray(data) ? data : (data.data || []);
            setDocuments(docsList);

        } catch (error) {
            console.error("Error fetching docs:", error);
        } finally {
            setIsLoadingDocs(false);
        }
    };

    // Helper: Format dung lượng file
    const formatFileSize = (bytes) => {
        if (!bytes) return "0 B";
        const k = 1024;
        const sizes = ["B", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };
    // --- MỚI: Hàm fetch History ---
    const fetchHistory = async () => {
        setIsLoadingHistory(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/history`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new Error("Failed to fetch history");
            const data = await response.json();
            // API trả về mảng trực tiếp
            setHistory(data || []);
        } catch (error) {
            console.error("Error fetching history:", error);
        } finally {
            setIsLoadingHistory(false);
        }
    };
    const handleDownloadFile = async (e, fileUrl, fileName) => {
        e.preventDefault(); // Ngăn việc mở tab mới mặc định

        try {
            // 1. Fetch file về dưới dạng Blob
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error("Network response was not ok");

            const blob = await response.blob();

            // 2. Tạo URL ảo cho Blob
            const blobUrl = window.URL.createObjectURL(blob);

            // 3. Tạo thẻ a ảo để kích hoạt download
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName || "downloaded_file";
            document.body.appendChild(link);
            link.click();

            // 4. Dọn dẹp
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Lỗi download:", error);
            // Fallback: Nếu lỗi fetch (ví dụ do CORS), mở tab mới để người dùng tự lưu
            window.open(fileUrl, "_blank");
        }
    };
    // Helper: Map Action Type
    const mapActionType = (type) => {
        const map = {
            "LOCK": "Khóa",
            "UNLOCK": "Mở khóa",
            "CLOSE": "Đóng",
            "CREATE": "Tạo mới",
            "UPDATE": "Cập nhật",
            "ACTIVATE": "Kích hoạt"
        };
        return map[type] || type;
    };

    // Helper: Format Date
    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return dateString.replace("T", " ");
    };

    // Handler xem chi tiết lịch sử (JSON change)
    // Tại AgentDetailModal.jsx hoặc EditAgentModal.jsx

    const handleViewHistoryDetail = (item) => {
        // Map Action Type sang tiếng Việt cho đẹp
        const mapAction = {
            "LOCK": "Khóa",
            "UNLOCK": "Mở khóa",
            "UPDATE": "Cập nhật",
            // ...
        };

        const detailData = {
            fieldName: mapAction[item.action_type] || item.action_type, // Hiển thị tên thao tác
            oldValue: item.old_value, // Truyền thẳng object {status: "ACTIVE"}
            newValue: item.new_value  // Truyền thẳng object {status: "LOCKED"}
        };

        // Gọi hàm set state để mở modal
        if (typeof handleUserHistoryDetail === 'function') {
            handleUserHistoryDetail(detailData);
        }
    };
    // --- Hàm gọi API Lịch sử User ---
    const fetchUserHistory = async () => {
        setIsLoadingUserHistory(true);
        try {
            const token = localStorage.getItem("access_token");
            // Endpoint: /api/v1/admin/users/users/agent/{id}/history
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/agent/${agent.id}/history`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) throw new Error("Failed to fetch user history");

            const data = await response.json();
            setUserHistory(data || []);

        } catch (error) {
            console.error("Error fetching user history:", error);
        } finally {
            setIsLoadingUserHistory(false);
        }
    };

    if (!isOpen) return null;

    // fallback nếu chưa có data thật cho tab Thông tin
    // const info = agent || {
    //     cifAgentParent: "",
    //     cifDltt: "",
    //     idDltt: "",
    //     trangThai: "",
    //     tenAgentChuQuan: "",
    //     tenDltt: "",
    //     taiKhoanGiaoDich: "",
    //     diaChiChiTiet: "",
    //     tenNguoiDaiDien: "",
    //     sdtNguoiDaiDien: "",
    //     maCbnvQuanLy: "",
    //     tenCbnvQuanLy: "",
    //     maDvkdPhatTrien: "",
    //     tenDvkdPhatTrien: "",
    //     nguoiTao: "",
    //     thoiGianTao: "",
    //     nguoiChinhSuaGanNhat: "",
    //     thoiGianChinhSuaGanNhat: "",
    // };

    const handleViewUser = (user) => {
        // Nếu API trả về field name khác mockUser, bạn cần map lại ở đây trước khi set
        setSelectedUser(user);
        setIsDetailOpen(true);
    };

    const handleUserHistoryDetail = (detail) => {
        setUserHistoryDetail(detail);
        setIsUserHistoryDetailOpen(true);
    };
    const info = agent || {};
    return (
        <div className="agent-modal-overlay">
            <div className="agent-modal">
                {/* Header */}
                <div className="agent-modal-header">
                    <h3>
                        Xem thông tin Đại lý - {info.idDltt || agent?.idDltt}
                    </h3>
                    <button className="agent-modal-close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                {/* Tabs */}
                <div className="agent-modal-tabs">
                    {TABS.map((tab) => (
                        <button
                            key={tab}
                            className={
                                "agent-tab" + (activeTab === tab ? " agent-tab-active" : "")
                            }
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Content */}
                <div className="agent-modal-content">
                    {activeTab === "Thông tin Đại lý" && (
                        <div className="agent-form-grid">
                            {/* Cột trái */}
                            <div className="agent-form-column">
                                <div className="form-group">
                                    <label>CIF Agent chủ quản <span className="required">*</span></label>
                                    <input type="text" value={info.cifAgentParent} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>CIF Đại lý thanh toán <span className="required">*</span></label>
                                    <input type="text" value={info.cifDltt} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>ID Đại lý thanh toán</label>
                                    <input type="text" value={info.idDltt} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Trạng thái</label>
                                    <input type="text" value={info.trangThai} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Tên người đại diện ĐLTT <span className="required">*</span></label>
                                    <input type="text" value={info.tenNguoiDaiDien} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Mã CBNV BVBank quản lý <span className="required">*</span></label>
                                    <input type="text" value={info.maCbnvQuanLy} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Mã ĐVKD phát triển <span className="required">*</span></label>
                                    <input type="text" value={info.maDvkdPhatTrien} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Người tạo</label>
                                    <input type="text" value={info.nguoiTao} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Người chỉnh sửa gần nhất</label>
                                    <input type="text" value={info.nguoiChinhSuaGanNhat || ""} readOnly />
                                </div>
                            </div>

                            {/* Cột phải */}
                            <div className="agent-form-column">
                                <div className="form-group">
                                    <label>Tên Agent chủ quản</label>
                                    <input type="text" value={info.tenAgentChuQuan} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Tên Đại lý thanh toán <span className="required">*</span></label>
                                    <input type="text" value={info.tenDltt} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Tài khoản giao dịch <span className="required">*</span></label>
                                    <input type="text" value={info.taiKhoanGiaoDich} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Địa chỉ chi tiết <span className="required">*</span></label>
                                    <input type="text" value={info.diaChiChiTiet} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>SĐT người đại diện ĐLTT <span className="required">*</span></label>
                                    <input type="text" value={info.sdtNguoiDaiDien} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Tên CBNV BVBank quản lý</label>
                                    <input type="text" value={info.tenCbnvQuanLy} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Tên ĐVKD phát triển</label>
                                    <input type="text" value={info.tenDvkdPhatTrien} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Thời gian tạo</label>
                                    <input type="text" value={info.thoiGianTao} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Thời gian chỉnh sửa gần nhất</label>
                                    <input type="text" value={info.thoiGianChinhSuaGanNhat || ""} readOnly />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "Hạn mức" && (
                        <div className="limit-form">
                            <div className="limit-row">
                                <div className="limit-col">
                                    <label>Hạn mức ngày <span className="required">*</span></label>
                                    <input type="text" className="limit-dropdown" value={info.hanMucNgay || "200.000.000 VND"} readOnly />
                                </div>
                                <div className="limit-col">
                                    <label>Hạn mức tháng <span className="required">*</span></label>
                                    <input type="text" className="limit-dropdown" value={info.hanMucThang || "5.000.000.000 VND"} readOnly />
                                </div>
                            </div>
                            {/* <div className="limit-row">
                                <div className="limit-col">
                                    <label>Ngày hiệu lực hạn mức <span className="required">*</span></label>
                                    <div className="limit-date-wrapper">
                                        <img src="/icons/icons8-calendar-100.png" alt="" className="limit-date-icon" />
                                        <input type="date" className="limit-date-input" value={info.ngayHieuLucHanMuc || ""} readOnly />
                                    </div>
                                </div>
                                <div className="limit-col" />
                            </div> */}
                        </div>
                    )}

                    {activeTab === "Thông tin User" && (
                        <div className="agent-user-tab">
                            <div className="agent-user-toolbar">
                                {/* 3. CHỈ HIỆN NÚT TẠO USER NẾU LÀ BANK_CREATE */}
                                {permissions.canCreate && (
                                    <button className="btn-primary" onClick={() => setIsCreateOpen(true)}>
                                        Tạo user
                                    </button>
                                )}
                                <div className="agent-user-search">
                                    <input
                                        type="text"
                                        placeholder="Tìm kiếm nhanh trong bảng..."
                                        value={userSearchTerm}
                                        onChange={(e) => setUserSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="agent-user-table-wrapper">
                                <table className="agent-user-table">
                                    <thead>
                                        <tr>
                                            <th>Thao tác</th>
                                            <th>Username</th>
                                            <th>User ID</th>
                                            <th>Mã KH (CIF)</th>
                                            <th>Nhóm quyền</th>
                                            <th>Trạng thái</th>
                                            <th>User tạo</th>
                                            <th>Branch tạo</th>
                                            <th>Ngày tạo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Loading State */}
                                        {isLoadingUsers && (
                                            <tr><td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>Đang tải dữ liệu...</td></tr>
                                        )}

                                        {/* Render Users */}
                                        {!isLoadingUsers && filteredUsers.length > 0 ? (
                                            filteredUsers.map((user) => {
                                                // Sử dụng hàm helper ở ngoài
                                                const statusInfo = getStatusInfo(user.status);
                                                return (
                                                    <tr key={user.id}>
                                                        <td className="action-cell">
                                                            <button
                                                                type="button"
                                                                className="icon-view-btn"
                                                                onClick={() => handleViewUser(user)}
                                                                title="Xem chi tiết"
                                                            >
                                                                <img src="/icons/icons8-eye-100.png" alt="Xem" className="icon-view" />
                                                            </button>
                                                        </td>
                                                        <td>{user.username}</td>
                                                        <td>{user.id}</td>
                                                        <td>{user.cif_number || user.cif || user.customer_code || ""}</td>
                                                        <td>{user.role}</td>
                                                        <td>
                                                            {/* Hiển thị vẫn dùng hàm getStatusInfo để lấy class màu sắc */}
                                                            <span className={`status-badge ${statusInfo.class}`}>
                                                                {statusInfo.text}
                                                            </span>
                                                        </td>
                                                        <td>{user.created_by}</td>
                                                        <td>{user.branch_created || user.branch_code || ""}</td>
                                                        <td>{user.created_at ? user.created_at.replace("T", " ") : ""}</td>
                                                    </tr>
                                                )
                                            })
                                        ) : (
                                            // Empty State
                                            !isLoadingUsers && (
                                                <tr>
                                                    <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                                                        {users.length > 0 && userSearchTerm
                                                            ? "Không tìm thấy kết quả phù hợp"
                                                            : "Không có dữ liệu user"
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {activeTab === "Lịch sử Đại lý" && (
                        <div className="agent-history-tab">
                            <div className="agent-history-table-wrapper">
                                <table className="agent-history-table">
                                    <thead>
                                        <tr>
                                            <th>Tạo bởi</th>
                                            <th>Duyệt bởi</th>
                                            <th>Ngày tạo</th>
                                            <th>Ngày duyệt</th>
                                            <th>ID đại lý</th>
                                            <th>User ID</th>
                                            <th>Mã KH Đại lý</th>
                                            <th>Loại giao dịch</th>
                                            <th>Trạng thái</th>
                                            <th>CBNV quản lý</th>
                                            <th>Branch quản lý</th>
                                            <th>Chi tiết</th>
                                            <th>Ghi chú</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingHistory && (
                                            <tr><td colSpan="13" style={{ textAlign: 'center', padding: 20 }}>Đang tải dữ liệu...</td></tr>
                                        )}
                                        {!isLoadingHistory && history.length === 0 && (
                                            <tr><td colSpan="13" style={{ textAlign: 'center', padding: 20 }}>Chưa có lịch sử</td></tr>
                                        )}

                                        {!isLoadingHistory && history.map((item, index) => (
                                            <tr key={item.id || index}>
                                                {/* Tạo bởi: performed_by */}
                                                <td>{item.performed_by}</td>

                                                {/* Duyệt bởi: approved_by */}
                                                <td>{item.approved_by || "-"}</td>

                                                {/* Ngày tạo */}
                                                <td>{formatDate(item.performed_at)}</td>

                                                {/* Ngày duyệt */}
                                                <td>{formatDate(item.approved_at)}</td>

                                                {/* ID Đại lý (Context) */}
                                                <td>{info.idDltt || info.id}</td>

                                                {/* User ID (Người thực hiện) */}
                                                <td>{item.performed_by}</td>

                                                {/* Mã KH (CIF) */}
                                                <td>{info.cifDltt || info.cif_number}</td>

                                                {/* Loại giao dịch */}
                                                <td>{mapActionType(item.action_type)}</td>

                                                {/* Trạng thái (Hành động đã xong -> Đã duyệt/Hoàn thành) */}
                                                <td>{item.approved_at ? "Đã duyệt" : "Hoàn thành"}</td>

                                                {/* CBNV Quản lý (Lấy từ context Agent hiện tại) */}
                                                <td>{info.tenCbnvQuanLy || info.manager_name}</td>

                                                {/* Branch Quản lý */}
                                                <td>{info.branchQuanLy || info.branch_code}</td>

                                                {/* Chi tiết (Click xem old/new value) */}
                                                <td
                                                    className="user-history-view"
                                                    onClick={() => handleViewHistoryDetail(item)}
                                                >
                                                    View
                                                </td>

                                                {/* Ghi chú */}
                                                <td>{item.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* --- CẬP NHẬT TAB LỊCH SỬ USER --- */}
                    {activeTab === "Lịch sử User" && (
                        <div className="user-history-tab">
                            <div className="user-history-table-wrapper">
                                <table className="agent-history-table">
                                    <thead>
                                        <tr>
                                            <th>Tạo bởi</th>
                                            <th>Duyệt bởi</th>
                                            <th>Ngày tạo</th>
                                            <th>Ngày duyệt</th>
                                            <th>Username</th>
                                            <th>User ID</th>
                                            <th>Mã KH</th>
                                            <th>Loại giao dịch</th>
                                            <th>Trạng thái</th>
                                            <th>CBNV quản lý</th>
                                            <th>Branch quản lý</th>
                                            <th>Chi tiết</th>
                                            <th>Ghi chú</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingUserHistory && (
                                            <tr><td colSpan="13" style={{ textAlign: "center", padding: 20 }}>Đang tải dữ liệu...</td></tr>
                                        )}
                                        {!isLoadingUserHistory && userHistory.length === 0 && (
                                            <tr><td colSpan="13" style={{ textAlign: "center", padding: 20 }}>Chưa có lịch sử user</td></tr>
                                        )}

                                        {!isLoadingUserHistory && userHistory.map((item, index) => (
                                            <tr key={item.id || index}>
                                                {/* Tạo bởi & Duyệt bởi */}
                                                <td>{item.performed_by}</td>
                                                <td>{item.approved_by || "-"}</td>

                                                {/* Ngày tạo & Ngày duyệt */}
                                                <td>{formatDate(item.performed_at)}</td>
                                                <td>{formatDate(item.approved_at)}</td>

                                                {/* Username/User ID: API hiện tại chưa trả về rõ ràng trong mẫu, 
                                                    tôi để fallback check các trường tiềm năng */}
                                                <td>{item.username || item.target_username || "-"}</td>
                                                <td>{item.user_id || item.target_user_id || "-"}</td>
                                                <td>{item.cif || "-"}</td>

                                                {/* Loại giao dịch */}
                                                <td>{mapActionType(item.action_type)}</td>

                                                {/* Trạng thái */}
                                                <td>{item.approved_at ? "Đã duyệt" : "Hoàn thành"}</td>

                                                {/* CBNV/Branch: Lấy theo Agent cha */}
                                                <td>{info.tenCbnvQuanLy || info.manager_name}</td>
                                                <td>{info.branchQuanLy || info.branch_code}</td>

                                                {/* Nút View */}
                                                <td className="user-history-view" onClick={() => handleViewHistoryDetail(item)}>
                                                    View
                                                </td>

                                                {/* Ghi chú */}
                                                <td>{item.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {activeTab === "Hồ sơ đăng ký" && (
                        <div className="agent-documents-tab">
                            <div className="agent-documents-table-wrapper">
                                <table className="agent-documents-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "60px" }}>STT</th>
                                            <th>Tên hồ sơ</th>
                                            <th style={{ width: "160px" }}>Dung lượng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Loading State */}
                                        {isLoadingDocs && (
                                            <tr>
                                                <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                                                    Đang tải hồ sơ...
                                                </td>
                                            </tr>
                                        )}

                                        {/* Empty State */}
                                        {!isLoadingDocs && documents.length === 0 && (
                                            <tr>
                                                <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                                                    Không có hồ sơ nào
                                                </td>
                                            </tr>
                                        )}

                                        {/* Data Rows */}
                                        {!isLoadingDocs && documents.map((doc, index) => (
                                            <tr key={doc.id || index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {/* Nếu có link thì hiển thị thẻ a, ngược lại hiện text thường */}
                                                    {doc.file_url ? (
                                                        <a
                                                            href={doc.file_url} // Vẫn giữ href để chuột phải có thể "Open in new tab"
                                                            onClick={(e) => handleDownloadFile(e, doc.file_url, doc.file_name)} // Gọi hàm khi click chuột trái
                                                            className="doc-link"
                                                            title="Bấm để tải về"
                                                            style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                        >
                                                            {doc.file_name || "Tài liệu không tên"}
                                                        </a>
                                                    ) : (
                                                        <span style={{ color: "#333" }}>
                                                            {doc.file_name || "Tài liệu không tên"}
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    {formatFileSize(doc.file_size || doc.size)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <UserDetailModal
                isOpen={isDetailOpen}
                onClose={() => setIsDetailOpen(false)}
                user={selectedUser}

                // --- BỔ SUNG CÁC PROPS NÀY ---
                agentId={agent?.id}           // Để gọi API lookup phone
                agentCif={agent?.cifDltt || agent?.cif_number} // Để hiển thị
                agentName={agent?.tenDltt || agent?.agent_name} // Để hiển thị
            />
            <HistoryDetailModal
                isOpen={isUserHistoryDetailOpen}
                onClose={() => setIsUserHistoryDetailOpen(false)}
                detail={userHistoryDetail}
            />
            <CreateUserModal
                isOpen={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                // --- THÊM CÁC PROPS SAU ---
                agentId={agent?.id}                // ID để gọi API create
                agentCif={agent?.cifDltt}          // CIF đại lý để hiển thị
                agentName={agent?.tenDltt}         // Tên đại lý để hiển thị
                isCenter={agent?.isCenter}
                branchCode={agent?.maDvkdPhatTrien}
                unitName={agent?.tenDvkdPhatTrien}
                // ---------------------------
                onSubmit={(data) => {
                    // Sau khi tạo thành công, reload lại danh sách user ở tab hiện tại
                    fetchUsers();
                    setIsCreateOpen(false);
                }}
            />
        </div>
    );
};

export default AgentDetailModal;